export const cm = (...props: string[]) => props.join(" ");
